import { delay } from '~/utils';

export const sequence = async <T>({
  method,
  list,
  showLogs = false,
  nextDelay = 0,
  data,
}: {
  method: any;
  list: any[];
  showLogs?: boolean;
  nextDelay?: number;
  data?: any;
}) => {
  let currentIndex = 0;
  let results: T[] = [];

  const next = async () => {
    try {
      const result = await method(list[currentIndex], data, {
        index: currentIndex,
        total: list.length,
      });

      results = [...results, ...result];

      if (showLogs) {
        console.log(
          'completed - sequence',
          currentIndex + 1,
          'of',
          list.length,
        );
      }
    } catch (error) {
      if (showLogs) {
        console.log('error - sequence', currentIndex + 1, 'of', list.length);
      }
    }

    currentIndex++;
    if (currentIndex + 1 <= list.length) {
      await delay(nextDelay);
      await next();
    }
  };

  if (list.length) {
    await next();
  }

  return results;
};
